/*
 * Created Date: Thursday May 5th 2022
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import React from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface AccordionCustomProps {
  headers: Array<string>;
  content?: any;
}

const AccordionCustom = ({
  headers,
  content,
  ...other
}: AccordionCustomProps) => {
  return (
    <Accordion
      sx={{ backgroundColor: "secondary.dark", width: "100%" }}
      {...other}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {headers}
      </AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
    </Accordion>
  );
};

export default AccordionCustom;
